import { ActiveFilters } from '../searchControls';

export const hasActiveFilters = (activeFilters: ActiveFilters): boolean =>
  activeFilters.status !== null ||
  activeFilters.team.length > 0 ||
  activeFilters.agent.length > 0 ||
  activeFilters.role.length > 0;
